"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Caption = _styledComponents["default"].span.withConfig({
  displayName: "Caption",
  componentId: "sc-1glj9d-0"
})(["font-size:11px;font-weight:400;line-height:16px;letter-spacing:0.6px;text-transform:uppercase;"]);

var _default = Caption;
exports["default"] = _default;